import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useComercialSection } from "./use-comercial-section";
import { ComercialSectionView } from "./view-comercial-section";

export function ComercialSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useComercialSection(props);

  return <ComercialSectionView {...vm} />;
}

export type * from "./types-comercial-section";
